import { InlineContainer, InlineImage, Truecaser, MachineOutput, ResponsiveStacker } from "../../../../src/components";
import * as React from 'react';
export default {
  InlineContainer,
  InlineImage,
  Truecaser,
  MachineOutput,
  ResponsiveStacker,
  React
};